import React from 'react';
import { getMatchStreamingProps } from '../../data/streaming/streamingUtils';
import { getPrincipaleOPrimoGruppo } from '../../data/utils/getPrincipaleOPrimoGruppo';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import LiveTournamentMatch from './LiveTournamentMatch';

function LiveTournament(props) {
    const matchesList = props.events.map(function(match) {
        const streamingMap = getMatchStreamingProps(match);
        const aggregata = getPrincipaleOPrimoGruppo(props.aggregate).idAggregata;
        match.openAggregata = aggregata;
        return <LiveTournamentMatch key={match.uniqueId} match={match} aggregata={aggregata} streaming={streamingMap && streamingMap[match.id]} />
    });

    let icon = props.categoryIcon;
    if (props.categoryRef === 0) {
        icon = iconCategoryCssClass(1, 4);
    }
    let desc = null;
    if (props.country?.descrizione) {
        desc = `${props.country.descrizione} - ${props.descrizione}`;
    } else {
        desc = props.descrizione;
    }

    return (
        <div className="header-template-2">
            <div className="heading">
                <span className="text-medium push-left push-right">{desc}</span>
                <span className={`border img-fluid ico-cat iconCategoryLive ${icon}`}></span>
            </div>
            {matchesList}
        </div>
    );
}

export default LiveTournament;